<template>
  <div class="loading">
    <van-loading type="spinner">
      正在登录
    </van-loading>
  </div>
</template>
<script>
import { pcWeixinLogin } from "../../api/http.js";
export default {
  data() {
    return {};
  },
  mounted() {
    this.wxLogin();
  },
  methods: {
    wxLogin() {
      let { code, state } = this.$route.query;
      pcWeixinLogin(code, state)
        .then(res => {
          localStorage.setItem("user_type", res.data.user_type);
          localStorage.setItem("login_token", res.data.token);
          this.$router.push("/");
        })
        .catch(err => {
          this.$router.go(-1);
        });
    }
  }
};
</script>

<style scoped>
.loading {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
</style>
